import {Component, OnInit, ChangeDetectorRef, AfterViewChecked} from '@angular/core';
import {ApiCallService, IParams} from './api-call.service';
import {SelectItem} from 'primeng/api';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements AfterViewChecked, OnInit {
  isLoggedIn = false;
  userName: string;
  userPassword: string;
  loading: boolean;
  displayDialog: boolean;
  clearing = {};
  clearing1 = {};
  clearing2 = {};
  uninstalling = {};
  selectedRecord: any = null;
  providers: SelectItem[] = [
    {label: 'None', value: ''},
    {label: 'Shopify', value: 'shopify'},
    {label: 'Wix', value: 'wix'},
    {label: 'Woo', value: 'woo'}
  ];
  records: any[] = [];
  selectedProvider = '';
  queryParam = {
    search: '',
    first: 0,
    rows: 8
  };
  totalRecords = 0;
  constructor(private apiCallService: ApiCallService, private change: ChangeDetectorRef) {
  }
  get apiUrl(): string {
    return this.apiCallService.apiUrl;
  }
  login(): void {
    const params: IParams = {
      module_fn: 'shared.admin.login',
      userName: this.userName,
      userPassword: this.userPassword
    };
    this.apiCallService.dynamicCall(params).toPromise().then((response) => {
      this.isLoggedIn = response.loggedIn;
      this.apiCallService.adminToken = response.userToken;
      this.apiCallService.adminUserName = response.userName;
    }, (reason) => console.error({reason}));
  }

  clearCache(credentialId: string): void {
    this.clearing[credentialId] = true;
    const params: IParams = {
      module_fn: 'shared.admin.clear_cache',
      credentialId,
      provider: this.selectedProvider
    };
    this.apiCallService.dynamicCall(params).toPromise().then((response) => {
      this.clearing[credentialId] = false;
      console.log({response});
      alert(JSON.stringify(response));
    }, (reason) => {
      console.error({reason});
      this.clearing[credentialId] = false;
    });
  }

  uninstall_app(credentialId: string): void {
    this.uninstalling[credentialId] = true;
    const params: IParams = {
      module_fn: 'shared.admin.uninstall_shopify_app',
      credentialId,
    };
    this.apiCallService.dynamicCall(params).toPromise().then((response) => {
      this.uninstalling[credentialId] = false;
      console.log({response});
      alert(JSON.stringify(response));
    }, (reason) => {
      console.error({reason});
      this.uninstalling[credentialId] = false;
    });
  }

  cleanAccount(credentialId: string, currentPlatform: string): void {
    this.clearing1[credentialId] = true;
    const params: IParams = {
      module_fn: 'shared.admin.clear_selected_account',
      credentialId,
      provider: this.selectedProvider,
      currentPlatform
    };
    this.apiCallService.dynamicCall(params).toPromise().then((response) => {
      this.clearing1[credentialId] = false;
      console.log({response});
      alert(JSON.stringify(response));
    }, (reason) => {
      console.error({reason});
      this.clearing1[credentialId] = false;
    });
  }

  cleanPlatformCredentials(credentialId: string, currentPlatform: string): void {
    this.clearing2[credentialId] = true;
    const params: IParams = {
      module_fn: 'shared.admin.clear_platform_credentials',
      credentialId,
      provider: this.selectedProvider,
      currentPlatform
    };
    this.apiCallService.dynamicCall(params).toPromise().then((response) => {
      this.clearing2[credentialId] = false;
      console.log({response});
      alert(JSON.stringify(response));
    }, (reason) => {
      console.error({reason});
      this.clearing2[credentialId] = false;
    });
  }
  loadData(event: any, isQuery: boolean = false): void {
    this.loading = true;
    const params: IParams = {
      module_fn: 'shared.admin.get_providers_data',
      first: (!isQuery) ? event.first : this.queryParam.first,
      rows: (!isQuery) ? event.rows : this.queryParam.rows,
      search: this.queryParam.search,
      provider: this.selectedProvider
    };
    this.apiCallService.dynamicCall(params).toPromise().then((response) => {
      console.log({response});
      this.totalRecords = response.totalRecords;
      this.records = response.records;
      this.loading = false;
    }, (reason) => {
      console.error({reason});
      this.loading = false;
    });
  }

  ngAfterViewChecked(): void {
    this.change.detectChanges();
  }

  selectRecord(event: any, record: any): void {
    this.selectedRecord = record;
    this.displayDialog = true;
    event.preventDefault();
  }

  ngOnInit(): void {
    this.change.markForCheck();
    const params: IParams = {
      module_fn: 'shared.admin.login',
      userName: this.apiCallService.adminUserName,
      userToken: this.apiCallService.adminToken
    };
    this.apiCallService.dynamicCall(params).toPromise().then((response) => {
      this.isLoggedIn = response.loggedIn;
      this.apiCallService.adminToken = response.userToken;
      this.apiCallService.adminUserName = response.userName;
    }, (reason) => console.error({reason}));
  }

  onDialogHide(): void {
    this.selectedRecord = null;
  }
}
